import {} from "./types";

import { SORT_BY } from "@Components/search/utils/algoliaData";
import { IProductsFilterState } from "./types";

export const PRODUCTS_LISTING_FILTER_INITIAL_STATE: IProductsFilterState = {
  isNavigationOpen: false,
  activeDropdownFilter: undefined,
  showMobileDrawerMenu: false,
  selectedNavigation: "1",
  selectedSortBy: SORT_BY.NONE,
  countSelectedFilterValues: 0,
  selectedFilterValues: undefined,
};

export const DEFAULT_PAGE = 1;

export const PRODUCTS_PER_BATCH = 24;

export const NAVIGATION_MENU_TEST_ID = "navigation-menu";

export const MOBILE_DRAWER_MENU_TEST_ID = "mobile-drawer-menu";

export const CLOSE_DRAWER_BUTTON_TEST_ID = "close-drawer-button";

export const CT_PRODUCT_LIMIT = 500;
